export const filterValues = [
  {
    id: 1,
    name: "Tipo de persona",
    value: "legal_type",
    open: false,
    options: [
      {
        id: 1,
        value: "personal",
        label: "Persona Física",
        applied: false,
        checked: false,
        filter_id: 1,
      },
      {
        id: 2,
        value: "enterprise",
        label: "Persona Moral",
        applied: false,
        checked: false,
        filter_id: 1,
      },
    ],
  },
  {
    id: 2,
    name: "Categoría",
    value: "category",
    open: false,
    options: [
      {
        id: 1,
        value: "regularization",
        label: "Regularización",
        applied: false,
        checked: false,
        filter_id: 2,
      },
      {
        id: 2,
        value: "accounting",
        label: "Servicios Contables",
        applied: false,
        checked: false,
        filter_id: 2,
      },
    ],
  },
  {
    id: 3,
    name: "Estatus",
    value: "status",
    open: false,
    options: [
      {
        id: 1,
        value: "active",
        label: "Activo",
        applied: false,
        checked: false,
        filter_id: 3,
      },
      {
        id: 2,
        value: "disabled",
        label: "Desactivado",
        applied: false,
        checked: false,
        filter_id: 3,
      },
    ],
  },
  {
    id: 4,
    name: "Periodicidad",
    value: "periodicity",
    open: false,
    options: [
      {
        id: 1,
        value: "monthly",
        label: "Mensual",
        applied: false,
        checked: false,
        filter_id: 4,
      },
      {
        id: 2,
        value: "bimonthly",
        label: "Bimestral",
        applied: false,
        checked: false,
        filter_id: 4,
      },
      {
        id: 3,
        value: "quarterly",
        label: "Trimestral",
        applied: false,
        checked: false,
        filter_id: 4,
      },
      {
        id: 4,
        value: "yearly",
        label: "Anual",
        applied: false,
        checked: false,
        filter_id: 4,
      },
      {
        id: 5,
        value: "unique",
        label: "Único",
        applied: false,
        checked: false,
        filter_id: 4,
      },
    ],
  },
  {
    id: 5,
    name: "Moneda",
    value: "currency",
    open: false,
    options: [
      {
        id: 1,
        value: "MXN",
        label: "MXN",
        applied: false,
        checked: false,
        filter_id: 5,
      },
    ],
  },
];
